import request from '@/util/request';
//搜索
export const getDeviceMaintennanceRecordList = (params, options) =>
request.get('/api/v4ward/repair/task/device/page', Object.assign({}, options, { params }));
//添加
export const addDeviceMaintennanceRecord = (params) =>
request.post('/api/v4ward/repair/task/device/save',params);
//查看
export const getDeviceMaintennanceRecordDetail = id =>
request.get('/api/v4ward/repair/task/device/detail?id='+ id);
//删除
export const removeDeviceMaintennanceRecord = (ids) =>
request.post('/api/v4ward/repair/task/device/remove?ids='+ids);
//修改
export const updateDeviceMaintennanceRecord = (params) =>
request.post('/api/v4ward/repair/task/device/update',params);